import { Injectable } from '@angular/core';
import {Resume} from '../../models/resume'

@Injectable()
export class ResumeService {

  /*private education: Resume = {
    title: 'Education',
    description: 'this is description',
    milestones: [
      {
        year: 2017,
        title: 'Bachelor Of Engineering',
        description: 'Pursued Computer science from Vasavi College Of Engineering(OU), Hyderabad, India and Successfully secured 80%'
      },
      {
        year: 2013,
        title: 'Intermediate',
        description: 'Completed my intermediate from NRI JR. College'
      },
      {
        year: 2010,
        title: 'Schooling',
        description: 'Did my schooling in Jubilee Hills Public School.'
      }
    ]
  };*/

  private experience: Resume = {
    title: 'Experience',
    description: 'this is description',
    milestones: [
      {
        year: 2017,
        title: 'Software Developer @Accolite Inc',
        description: `My first company in my professional career. 
        Worked as Java developer for brief period.
        Working as full stack web-developer. 
        I work on technologies like NodeJs, Angular(1/5), Spring MVC on daily basis`
      },
      {
        year: 2017,
        title: 'Intern @Accolite Inc',
        description: `Even as a intern took up 
        challenging tasks and developed a complete feature in our product`
      },
    ]
  };

  constructor() { }

  getExperienceData() {
    return this.experience;
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/displayer/resume/resume.service.ts